import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  orderNoteFromModel,
  validateOrderNoteCondition,
  type OrderNoteState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ORDER_NOTE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderNoteState>>,
): ConditionType<OrderNoteState, ModelCondition.OrderNote> => ({
  name: CONDITION_NAMES[ModelCondition.ORDER_NOTE],
  description(state) {
    const value = state.trim();
    return value
      ? `Order note contains: ${value}`
      : "Order note contains: none";
  },
  Details(props: ConditionTypeDetailsProps<OrderNoteState>) {
    return React.createElement(Details, props);
  },
  empty: "",
  fromModel(model) {
    return orderNoteFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.ORDER_NOTE, contains: state.trim() };
  },
  valid(state) {
    return validateOrderNoteCondition(state).valid;
  },
});
